import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Header from 'components/AppBar';
import List from 'components/List';
import ListItem from 'components/List/ListItem';
import ApprovedTag from 'components/Tags/ApprovedTag';
import BreakTag from 'components/Tags/BreakTag';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { DashboardReportDetail } from 'models/dashboardReports';
import { TravelType } from 'models/enums/travelType';

import { IconImg, Info, ReportDetailsTextGroup, ReportTagContainer, DateTitle, OrderNo } from '../styles';

const ListOfReports = () => {
  const history = useHistory<{ values: DashboardReportDetail[]; dateTitle?: string }>();
  const { t } = useStoreTranslation();
  const [reportValues, setValues] = useState<DashboardReportDetail[]>([]);
  const [title, setTitle] = useState<string>();

  const renderTag = (status: string) => {
    switch (status) {
      case 'Expired':
        return <BreakTag brightColor noIcon reason={t('dashboard.card.expiredTag')} />;
      case 'Reproved':
        return <BreakTag brightColor noIcon reason={t('dashboard.card.reprovedTag')} />;
      case 'Approved':
        return <ApprovedTag noIcon />;
      case 'Confirmed':
        return <ApprovedTag noIcon />;
      default:
        return null;
    }
  };

  useEffect(() => {
    setValues(history.location.state.values);
    setTitle(history.location.state.dateTitle);
  }, [history.location.state.values, history.location.state.dateTitle]);

  return (
    <>
      <Header goBack={() => history.push('/corporate/dashboardReports')}>{title}</Header>
      <List>
        {reportValues.map((item: DashboardReportDetail, index: number) => (
          <ListItem key={index}>
            <Info>
              <IconImg
                src={
                  item.type === TravelType.Flight ? '/corporate/images/plane-outline-32.svg' : '/corporate/images/bedroom-outline-16.svg'
                }
              />
              <ReportDetailsTextGroup>
                <DateTitle>{item.name}</DateTitle>
                <OrderNo>Order No: {item.itineraryId}</OrderNo>
              </ReportDetailsTextGroup>
              <ReportTagContainer>{renderTag(item.status)}</ReportTagContainer>
            </Info>
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default ListOfReports;
